import { useContext } from 'react'

import { ShareContext, TShareContext } from 'modules/share/context'

export const useShare = (): TShareContext => useContext(ShareContext)
